import { render, staticRenderFns } from "./ReviewTermsAndConditions.vue?vue&type=template&id=222feba3&"
import script from "./ReviewTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./ReviewTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports